import {object, string} from 'yup';

import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateServiceOrderType = (scopes: string[], evaluatorParams: ScopeValues) => {
  const {serviceOrderType} = validateServiceOrderEvaluatorParams(evaluatorParams);

  if (isNil(serviceOrderType)) {
    return false;
  }

  return scopes.includes(serviceOrderType);
};

// export only for testing purposes
export const validateServiceOrderEvaluatorParams = (evaluatorParams: ScopeValues | null) =>
  serviceOrderParamsSchema.validateSync(evaluatorParams);

const serviceOrderParamsSchema = object({
  serviceOrderType: string().nullable(),
});
